export enum PROJECT {
  FAST = 'csgofast',
  FAST_NEW = 'csgofast-new',
  MARKET = 'market',
  AUTH = 'auth',
}
